import { Fragment } from 'react';

import { lerTextoRico } from '@/data/textoRico';
import type { TrechoDeTexto } from '@/data/textoRico';

/**
 * Mostra o texto com formatação da ficha.
 *
 * Sem `dangerouslySetInnerHTML`, e essa é a decisão inteira: o valor gravado é
 * texto com marcas (`**assim**`), e o que chega ao DOM são elementos React
 * montados aqui. Não há caminho por onde marcação escrita numa ficha vire nó
 * executável na tela de quem lê prontuário.
 */
export function TextoFormatado({ texto, style }: { texto: string; style?: React.CSSProperties }) {
    const blocos = lerTextoRico(texto);
    if (!blocos.length) return null;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, ...style }}>
            {blocos.map((bloco, i) => {
                if (bloco.tipo === 'lista') {
                    const Lista = bloco.ordenada ? 'ol' : 'ul';
                    return (
                        <Lista key={`b${String(i)}`} style={{ margin: 0, paddingLeft: 20, display: 'flex', flexDirection: 'column', gap: 3 }}>
                            {bloco.itens.map((item, k) => (
                                <li key={`i${String(k)}`}><Trechos trechos={item} /></li>
                            ))}
                        </Lista>
                    );
                }
                return (
                    <p key={`b${String(i)}`} style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
                        <Trechos trechos={bloco.trechos} />
                    </p>
                );
            })}
        </div>
    );
}

function Trechos({ trechos }: { trechos: TrechoDeTexto[] }) {
    return (
        <>
            {trechos.map((t, i) => {
                if (t.tipo === 'negrito') return <strong key={`t${String(i)}`} style={{ fontWeight: 600 }}>{t.texto}</strong>;
                if (t.tipo === 'italico') return <em key={`t${String(i)}`}>{t.texto}</em>;
                return <Fragment key={`t${String(i)}`}>{t.texto}</Fragment>;
            })}
        </>
    );
}
